import { parseScope } from '@platform/contracts';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';

import { useMe } from './queries';
import { effectiveScope, storeScope } from './scope';

/**
 * Alcance actual (Todas / Todas de <cliente> / una empresa). Vive en la URL (`?scope=`) para que un
 * link compartido abra la misma vista, y se recuerda en localStorage como default.
 */
export function useScope() {
  const me = useMe();
  const search = useSearch({ strict: false });
  const navigate = useNavigate();
  const scope = effectiveScope(me, search.scope);

  useEffect(() => {
    storeScope(scope);
  }, [scope]);

  const setScope = useCallback(
    (next: string) => {
      storeScope(next);
      void navigate({
        to: '.',
        search: (prev: Record<string, unknown>) => ({ ...prev, scope: next }),
      });
    },
    [navigate],
  );

  return { scope, parsed: parseScope(scope) ?? { kind: 'all' as const }, setScope };
}
